import { LinkSpan } from "../../linkSpan";
import { Routes } from "../../../common/Routes";
import { Tooltip } from "antd";

export enum ObtainedViaType {
  UserGroup = "UserGroup",
  SystemUserGroup = "SystemUserGroup",
  DirectAccess = "DirectAccess",
  NotApplicable = "NotApplicable",
}

export interface ObtainedViaForCurrentAccessControl {
  render(filteredSystemResourceTypeId: string, accessVisibilityTabKey?: string): React.ReactElement;

  stringifiedId(): string;

  type: ObtainedViaType;
  name: string;
}

export class ObtainedViaForUserGroup implements ObtainedViaForCurrentAccessControl {
  type: ObtainedViaType.UserGroup = ObtainedViaType.UserGroup;
  name: string;
  id: string;
  typeId: string;
  userGroupTypeUniqueName: string;
  userGroupUniqueName: string;

  constructor(input: {
    name: string;
    id: string;
    typeId: string;
    userGroupUniqueName: string;
    userGroupTypeUniqueName: string;
  }) {
    this.name = input.name;
    this.id = input.id;
    this.typeId = input.typeId;
    this.userGroupUniqueName = input.userGroupUniqueName;
    this.userGroupTypeUniqueName = input.userGroupTypeUniqueName;
  }

  render(filteredSystemResourceTypeId: string, accessVisibilityTabKey: string): React.ReactElement {
    return (
      <div className="obtained-via-cell">
        <LinkSpan
          to={`${Routes.UserGroups.basePath}/${this.userGroupTypeUniqueName}/${this.userGroupUniqueName}/access-visibility/${filteredSystemResourceTypeId}/${accessVisibilityTabKey}`}
          keyId={this.id}
          text={`${this.name} (Business team)`}
          className={undefined}
          target={undefined}
          active={undefined}
          matomoFn={undefined}
        />
      </div>
    );
  }

  stringifiedId(): string {
    return JSON.stringify({ type: this.type, id: this.id, typeId: this.typeId });
  }
}

export class ObtainedViaForSystemUserGroup implements ObtainedViaForCurrentAccessControl {
  type: ObtainedViaType.SystemUserGroup = ObtainedViaType.SystemUserGroup;
  name: string;
  id: string;
  systemId: string;

  constructor(input: { name: string; id: string; systemId: string }) {
    this.name = input.name;
    this.id = input.id;
    this.systemId = input.systemId;
  }

  render(): React.ReactElement {
    return (
      <div className="obtained-via-cell">
        {" "}
        <Tooltip
          title={`This access is granted to the user through the user group "${this.name}", not through the business team.`}
        >
          <span className="not-obtained-by-DAM">{this.name} (Sisense Group)</span>
        </Tooltip>
      </div>
    );
  }

  stringifiedId(): string {
    return JSON.stringify({ type: this.type, id: this.id, systemId: this.systemId });
  }
}

export class ObtainedViaForDirectAccess implements ObtainedViaForCurrentAccessControl {
  type: ObtainedViaType.DirectAccess = ObtainedViaType.DirectAccess;
  name: string;

  constructor(input: { name: string }) {
    this.name = input.name;
  }

  render(): React.ReactElement {
    return (
      <div className="obtained-via-cell">
        <Tooltip title="This access is granted directly to the user, not through any user group or business team.">
          <span className="not-obtained-by-DAM">{this.name}</span>
        </Tooltip>
      </div>
    );
  }

  stringifiedId(): string {
    return JSON.stringify({ type: this.type });
  }
}

export class ObtainedViaNotApplicable implements ObtainedViaForCurrentAccessControl {
  name: string;
  type: ObtainedViaType.NotApplicable = ObtainedViaType.NotApplicable;

  constructor(input: { name: string }) {
    this.name = input.name;
  }

  render(): React.ReactElement {
    return (
      <div className="obtained-via-cell">
        <Tooltip title="Obtained via is not applicable">
          <span className="not-obtained-by-DAM">{this.name}</span>
        </Tooltip>
      </div>
    );
  }
  stringifiedId(): string {
    return JSON.stringify({ type: this.type });
  }
}

export function initializeObtinedViaForCurrentAccessControl(
  input: ObtainedViaForCurrentAccessControl
): ObtainedViaForCurrentAccessControl {
  if (input.type === ObtainedViaType.SystemUserGroup) {
    return new ObtainedViaForSystemUserGroup({
      name: input.name,
      id: (input as ObtainedViaForSystemUserGroup).id,
      systemId: (input as ObtainedViaForSystemUserGroup).systemId,
    });
  } else if (input.type === ObtainedViaType.UserGroup) {
    return new ObtainedViaForUserGroup({
      name: input.name,
      id: (input as ObtainedViaForUserGroup).id,
      typeId: (input as ObtainedViaForUserGroup).typeId,
      userGroupUniqueName: (input as ObtainedViaForUserGroup).userGroupUniqueName,
      userGroupTypeUniqueName: (input as ObtainedViaForUserGroup).userGroupTypeUniqueName,
    });
  } else if (input.type === ObtainedViaType.NotApplicable) {
    return new ObtainedViaNotApplicable({ name: input.name });
  } else {
    return new ObtainedViaForDirectAccess({ name: input.name });
  }
}
